"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;

var react_1 = __importDefault(require("react"));

var Modal_styles_1 = require("./Modal.styles");

var Modal = function Modal(_a) {
  var children = _a.children,
      header = _a.header,
      footer = _a.footer,
      handleClose = _a.handleClose,
      maxWidth = _a.maxWidth,
      minWidth = _a.minWidth,
      frameBackgroundRgba = _a.frameBackgroundRgba,
      panelBackground = _a.panelBackground,
      closeButtonColour = _a.closeButtonColour,
      closeIconColour = _a.closeIconColour,
      frameDataTestid = _a.frameDataTestid,
      wrapperDataTestid = _a.wrapperDataTestid,
      panelDataTestid = _a.panelDataTestid,
      closeButtonId = _a.closeButtonId;
  return react_1.default.createElement(Modal_styles_1.ModalFrame, {
    tabIndex: -1,
    frameBackgroundRgba: frameBackgroundRgba,
    "data-testid": frameDataTestid
  }, react_1.default.createElement(Modal_styles_1.ModalWrapper, {
    "data-testid": wrapperDataTestid,
    maxWidth: maxWidth,
    minWidth: minWidth
  }, react_1.default.createElement(Modal_styles_1.ModalPanel, {
    role: "dialog",
    panelBackground: panelBackground,
    "data-testid": panelDataTestid
  }, react_1.default.createElement(Modal_styles_1.ModalHeader, null, header && header()), children, footer && react_1.default.createElement(Modal_styles_1.ModalFooter, null, footer())), react_1.default.createElement(Modal_styles_1.CloseButton, {
    onClick: handleClose,
    closeButtonColour: closeButtonColour,
    closeIconColour: closeIconColour,
    "data-testid": closeButtonId
  })));
};

exports.Modal = Modal;